import Vue from 'vue';
import Vuex from 'vuex';
import * as getters from './getters';
import * as actions from './actions';
import * as mutations from './mutations';
Vue.use(Vuex);

const state = {
  fetching: false,
  LoggedIn: false,
  userInfo: {},
  error: false,
  authError: false,
  userType: null,
  errorMessage: '',
  authErrorMessage: '',
  successMessage: '',
  success: false,
  ubication: {},
  carreras: [],
  industrias: [],
  requestResult: {
    status: '',
    message: '',
    showMessage: false
  },
  resultadosGlobalesTest: {},
  stateTest: {},
  nextQuestionTest: null,
  listaPublicaciones: [],
  publicacionSeleccionada: null
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
